enum TollAccountType {
    Personal = 'PERSONAL',
    Business = 'BUSINESS', // TR2Only
    Mixed = 'MIXED',
}

export default TollAccountType;
